import React from 'react';

import PropTypes from 'prop-types';

import { Card, CardHeader } from '../../../Components/Common';

import { FibreAddressLine } from './FibreAddressLine';

import './FibreAddress.css';

const FibreAddressC = ({ address = {}, onUpdateAddress, ...props }) => {

  return (
    <div className='fibre-address-container' {...props} automationid="SalesLead_Div_FibreAddressContainer_0">
      <p className='fibre-address title' automationid="SalesLead_Div_FibreAddressTitle_0">Fibre installation address:</p>
      <p className='fibre-address subtitle' automationid="SalesLead_Div_FibreAddressSubtitle_0">This is where your fibre will be installed and activated by our technicians</p>

      <Card automationidattr={`FibreAddress`}>
        <CardHeader automationidattr={`FibreAddress`}>
          <div className='fibre-status-container' automationid="SalesLead_Div_FibreStatusContatiner_0">
            <p className='fibre-status-label' automationid="SalesLead_Div_FibreStatusLabel_0">Fibre Status</p>
            <p><span className='fibre-status-availability' automationid="SalesLead_Div_FibreStatusAvailability_0">AVAILABLE</span></p>
            <p className='fibre-status-description' automationid="SalesLead_Div_FibreStatusDescription_0">This means that your address is fibre ready and installation can be scheduled.</p>
          </div>
        </CardHeader>
        <div className='fibre-address-details' automationid="SalesLead_Div_FibreAddressDetails_0">
          {Object.keys(address).map(key => {

            return (
              (key !== "longitude" && key !== "latitude" && key !== "docid" && key !== "formattedAddress" && key !== "seoid" && key !== "streetNumber" && key !== "streetName")
                ? <FibreAddressLine
                  key={key}
                  label={key}
                  value={address[key]}
                  onValueSave={(value) => {

                    onUpdateAddress({
                      key,
                      value,
                    })
                  }}
                />
                : null
            );
          })}
        </div>
      </Card>
    </div>
  );
}

FibreAddressC.propTypes = {
  address: PropTypes.object.isRequired,
  onUpdateAddress: PropTypes.func,
};

export const FibreAddress = FibreAddressC;
